var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'icon')?_c('Icon',{staticClass:"icon",attrs:{"name":"notification-lightning"}}):(_vm.type === 'title')?_c('div',[_vm._v("Ваш аккаунт будет заблокирован. Дней до блокировки: "+_vm._s(_vm.item.info.daysToBlock))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }